// context/SuggestionsContext.js
import React, { createContext, useContext, useState } from "react";

const SuggestionsContext = createContext();

export const SuggestionsProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SuggestionsContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </SuggestionsContext.Provider>
  );
};

export { SuggestionsContext };

export const useSuggestions = () => useContext(SuggestionsContext);
